<template>
  <span class="currency-symbol">{{ displayValue }}</span>
</template>

<script>
export default {
  name: 'DisplayCurrency',
  props: {
    currency: {
      type: String,
      default: '',
    },
  },
  computed: {
    slotText () {
      const slotNodes = this.$slots.default || [];
      const text = slotNodes
        .map((node) => (node && node.text ? node.text : ''))
        .join('')
        .trim();
      return text;
    },
    originalCurrency () {
      return (this.slotText || this.currency || '').toString().trim();
    },
    currencyCodeUppercase () {
      return this.originalCurrency.toUpperCase();
    },
    mappedSymbol () {
      if (this.currencyCodeUppercase === 'AED') return '\uE910';
      if (this.currencyCodeUppercase === 'SAR') return '\uE900';
      return '';
    },
    displayValue () {
      return this.mappedSymbol || this.originalCurrency;
    },
  },
};
</script>

<style>
.currency-symbol {
  font-family: 'IBM Plex Sans', sans-serif !important;
  font-size: 1.2em;
  margin-right: 0.2em;
}
</style>
